// @flow

export const toNumber = (value: any, fallback: number = 0): number => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : fallback;
  if (typeof value === 'string') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }
  if (value && value.sale && value.sale.raw !== undefined) {
    return toNumber(value.sale.raw, fallback);
  }
  if (value && value.raw !== undefined) {
    return toNumber(value.raw, fallback);
  }
  return fallback;
};

const getProductId = product => {
  return product ? product.id || product._id || '' : '';
};

const getProductTitle = product => {
  return product ? product.title || product.name || '' : '';
};

const getProductBrand = product => {
  if (!product) return '';
  return product.brand || product.supplier || (product.meta && product.meta.supplier) || '';
};

export const buildItemFromCartItem = (item: any): Object => {
  const product = item.product || {};
  const productPrice = item.product_price || {};
  const quantity = toNumber(item.quantity, 1);
  const price =
    item.price && item.price.sale
      ? toNumber(item.price.sale.raw)
      : toNumber(productPrice.price);

  return {
    productId: getProductId(product),
    productTitle: getProductTitle(product),
    brand: getProductBrand(product),
    productPriceId: productPrice.id || productPrice._id || '',
    quantity,
    price,
    value: price * quantity,
    currency: 'KRW',
    variant: productPrice.part_number || productPrice.id || productPrice._id || '',
    partNumber: productPrice.part_number || '',
    unit: productPrice.unit || '',
  };
};

export const buildItemFromOrderItem = (item: any): Object => {
  return buildItemFromCartItem(item);
};

export const buildItemFromProductPriceRow = ({
  productId,
  productTitle,
  brand,
  productPriceId,
  rowData,
  quantity,
}: {
  productId: string,
  productTitle: string,
  brand: string,
  productPriceId: string,
  rowData: any,
  quantity: any,
}): Object => {
  const safeQuantity = toNumber(quantity, 1);
  const price = rowData ? toNumber(rowData.price) : 0;

  return {
    productId,
    productTitle,
    brand,
    productPriceId,
    quantity: safeQuantity,
    price,
    value: price * safeQuantity,
    currency: 'KRW',
    variant: rowData && rowData.part_number ? rowData.part_number : productPriceId,
    partNumber: rowData && rowData.part_number ? rowData.part_number : '',
    unit: rowData && rowData.unit ? rowData.unit : '',
  };
};

export const mapItemsToGA4 = (items: any[]): any[] => {
  return items.map((item, index) => ({
    item_id: item.productId || item.id || '',
    item_name: item.productTitle || item.title || '',
    item_brand: item.brand || '',
    item_variant: item.variant || item.partNumber || item.productPriceId || '',
    part_number: item.partNumber || '',
    product_price_id: item.productPriceId || '',
    unit: item.unit || '',
    price: toNumber(item.price),
    quantity: toNumber(item.quantity, 1),
    index,
  }));
};



// WEBPACK FOOTER //
// ./src/lib/tracking/ecommerce.js